import { Chart, Line, Bar } from "react-chartjs-2"

export default function Test(props){

    if(props.tipo_s!=='bar'){
        return <Line  data={props.firedata} options = {props.options}/>}
    else{
        return <Bar  data={props.firedata} options = {props.options}/>}

    }
